import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {SessionDataApi} from '../../api/session/session.api.class';
import {share} from 'rxjs/operators';
import { ChargeAmount } from '../../interfaces/SessionDisplayInformation';
import { CardSchema } from '../../interfaces/card/CardSchema';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private paymentMethodPromotion:Subject<string>;
  private paymentMethodList:Subject<boolean>;
  private selectedPaymentMethod: Subject<string>;
  private paymentMethodListLock:Subject<boolean>;
  private selectedChargeAmount:BehaviorSubject<ChargeAmount>;
  private currencyCodeListLock: BehaviorSubject<boolean>;
  private supportedCardSchema: BehaviorSubject<CardSchema[]>;
  constructor(private sessionDataApi: SessionDataApi) {
    this.paymentMethodPromotion = new Subject<string>();
    this.paymentMethodList = new Subject<boolean>();
    this.selectedPaymentMethod = new Subject<string>();
    this.paymentMethodListLock = new Subject<boolean>();
    this.selectedChargeAmount = new BehaviorSubject<ChargeAmount>({
      currency:'',
      amount:0
    });
    this.currencyCodeListLock = new BehaviorSubject<boolean>(false);
    this.supportedCardSchema = new BehaviorSubject<CardSchema[]>([]);
  }

  getSessionData(token: any,version?:number) {
    return this.sessionDataApi.getSessionToken(token,version)
    .pipe(share());
  }

  getSessionTokenWithNoSession(token: any,complete?:boolean) {
    return this.sessionDataApi.getSessionTokenWithNoSession(token,complete);
  }

  login(): Observable<string> {
    return this.sessionDataApi.login();
  }

  getVirtualTwoBaseurl():string{
    return "virtual-v2";
  }

  emitPaymentMethodPromotion(method:string):void{
    this.paymentMethodPromotion.next(method);
  }

  getEmitPaymentMethodPromotion():Observable<string>{
    return this.paymentMethodPromotion.asObservable();
  }

  getPaymentMethodList():Observable<boolean>{
    return this.paymentMethodList.asObservable();
  }

  emitPaymentMethodList(val:boolean){
    this.paymentMethodList.next(val);
  }

  emitSelectedPaymentMethod(method:string):void{
    this.selectedPaymentMethod.next(method);
  }
  getEmitSelectedPaymentMethod():Observable<string>{
    return this.selectedPaymentMethod.asObservable();
  }

  emitPaymentMethodListLock(val:boolean):void{
    this.paymentMethodListLock.next(val);
  }

  getPaymentMethodListLock():Observable<boolean>{
    return this.paymentMethodListLock.asObservable();
  }

  getSelectedChargeAmount():BehaviorSubject<ChargeAmount>{
    return this.selectedChargeAmount;
  }

  setSelectedChargeAmount(amount: ChargeAmount){
    this.selectedChargeAmount.next(amount);
  }

  getCurrencyCodeListLock(): BehaviorSubject<boolean>{
    return this.currencyCodeListLock;
  }

  setCurrencyCodeListLock(val: boolean){
    this.currencyCodeListLock.next(val);
  }

  getSupportedCardSchema(): Observable<CardSchema[]>{
    return this.supportedCardSchema.asObservable();
  }

  setSupportedCardSchema(val: CardSchema[]){
    this.supportedCardSchema.next(val);
  }
}
